export const COUNTRY_DEFAULT_LOCALE = {
    // Americas
    CA: "en-CA",
    US: "en-US",
    AG: "en-AG",
    BS: "en-BS",
    BB: "en-BB",
    BZ: "en-BZ",
    DM: "en-DM",
    GD: "en-GD",
    HT: "fr-HT",
    JM: "en-JM",
    KN: "en-KN",
    LC: "en-LC",
    VC: "en-VC",
    TT: "en-TT",
    AR: "es-AR",
    BO: "es-BO",
    BR: "pt-BR",
    CL: "es-CL",
    CO: "es-CO",
    CR: "es-CR",
    CU: "es-CU",
    DO: "es-DO",
    EC: "es-EC",
    SV: "es-SV",
    GT: "es-GT",
    HN: "es-HN",
    MX: "es-MX",
    NI: "es-NI",
    PA: "es-PA",
    PY: "es-PY",
    PE: "es-PE",
    GY: "en-GY",
    SR: "nl-SR",
    UY: "es-UY",
    VE: "es-VE",
    // Europe
    AL: "sq-AL",
    AD: "ca-AD",
    AT: "de-AT",
    BE: "nl-BE",
    BA: "bs-BA",
    BG: "bg-BG",
    HR: "hr-HR",
    CZ: "cs-CZ",
    DK: "da-DK",
    EE: "et-EE",
    FI: "fi-FI",
    FR: "fr-FR",
    DE: "de-DE",
    GR: "el-GR",
    HU: "hu-HU",
    IS: "is-IS",
    IT: "it-IT",
    LV: "lv-LV",
    LT: "lt-LT",
    LU: "de-LU",
    BY: "be-BY",
    CY: "el-CY",
    GB: "en-GB",
    IE: "en-IE",
    LI: "de-LI",
    MD: "ro-MD",
    MC: "fr-MC",
    MT: "mt-MT",
    RU: "ru-RU",
    SM: "it-SM",
    UA: "uk-UA",
    VA: "it-VA",
    MK: "mk-MK",
    ME: "sr-ME",
    NL: "nl-NL",
    NO: "nb-NO",
    PL: "pl-PL",
    PT: "pt-PT",
    RO: "ro-RO",
    RS: "sr-RS",
    SK: "sk-SK",
    SI: "sl-SI",
    ES: "es-ES",
    SE: "sv-SE",
    CH: "de-CH",
    TR: "tr-TR",
    // Africa & Middle East
    DZ: "fr-DZ",
    AO: "pt-AO",
    BJ: "fr-BJ",
    BW: "en-BW",
    BF: "fr-BF",
    BI: "fr-BI",
    CV: "pt-CV",
    CM: "fr-CM",
    CD: "fr-CD",
    CF: "fr-CF",
    TD: "fr-TD",
    KM: "fr-KM",
    CG: "fr-CG",
    CI: "fr-CI",
    DJ: "fr-DJ",
    EG: "ar-EG",
    GQ: "es-GQ",
    ER: "ti-ER",
    SZ: "en-SZ",
    ET: "am-ET",
    GA: "fr-GA",
    GM: "en-GM",
    GH: "en-GH",
    GN: "fr-GN",
    GW: "pt-GW",
    KE: "sw-KE",
    LS: "en-LS",
    LR: "en-LR",
    LY: "ar-LY",
    MA: "fr-MA",
    MG: "fr-MG",
    MW: "en-MW",
    ML: "fr-ML",
    MR: "ar-MR",
    MU: "en-MU",
    MZ: "pt-MZ",
    NA: "en-NA",
    NE: "fr-NE",
    NG: "en-NG",
    RW: "rw-RW",
    ST: "pt-ST",
    SN: "fr-SN",
    SC: "en-SC",
    SL: "en-SL",
    SO: "so-SO",
    ZA: "en-ZA",
    SS: "en-SS",
    SD: "ar-SD",
    TZ: "sw-TZ",
    TG: "fr-TG",
    TN: "fr-TN",
    UG: "en-UG",
    ZM: "en-ZM",
    ZW: "en-ZW",
    IL: "he-IL",
    SA: "ar-SA",
    AE: "ar-AE",
    QA: "ar-QA",
    KW: "ar-KW",
    BH: "ar-BH",
    IR: "fa-IR",
    IQ: "ar-IQ",
    JO: "ar-JO",
    LB: "ar-LB",
    OM: "ar-OM",
    PS: "ar-PS",
    SY: "ar-SY",
    YE: "ar-YE",
    // Asia / Oceania
    AF: "fa-AF",
    AM: "hy-AM",
    AZ: "az-AZ",
    BD: "bn-BD",
    BT: "dz-BT",
    BN: "ms-BN",
    KH: "km-KH",
    CN: "zh-CN",
    GE: "ka-GE",
    IN: "hi-IN",
    ID: "id-ID",
    JP: "ja-JP",
    KZ: "kk-KZ",
    KG: "ky-KG",
    LA: "lo-LA",
    MY: "ms-MY",
    MV: "dv-MV",
    MN: "mn-MN",
    MM: "my-MM",
    NP: "ne-NP",
    KP: "ko-KP",
    PK: "ur-PK",
    PH: "fil-PH",
    SG: "en-SG",
    KR: "ko-KR",
    LK: "si-LK",
    TW: "zh-TW",
    TJ: "tg-TJ",
    VN: "vi-VN",
    TH: "th-TH",
    TL: "pt-TL",
    TM: "tk-TM",
    UZ: "uz-UZ",
    AU: "en-AU",
    NZ: "en-NZ",
    FJ: "en-FJ",
    PG: "en-PG",
    WS: "sm-WS",
    SB: "en-SB",
    TO: "to-TO",
    VU: "bi-VU",
    FM: "en-FM",
    PW: "en-PW",
    MH: "en-MH",
    NR: "en-NR",
    KI: "en-KI",
    TV: "en-TV",
};
